// Editorial Article - Scroll Animations and Interactions

document.addEventListener('DOMContentLoaded', function() {
  
  // Parallax effect on hero image
  const heroImage = document.querySelector('[data-parallax-image] img');
  
  if (heroImage) {
    window.addEventListener('scroll', () => {
      const scrolled = window.scrollY;
      const rate = scrolled * 0.3;
      
      if (scrolled < window.innerHeight) {
        heroImage.style.transform = `translateY(${rate}px) scale(1.1)`;
      }
    }, { passive: true });
  }

  // Intersection Observer for reveal animations
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -10% 0px',
    threshold: 0.1
  };

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      }
    });
  }, observerOptions);

  // Observe all reveal elements
  const revealElements = document.querySelectorAll('[data-reveal]');
  revealElements.forEach(element => {
    revealObserver.observe(element);
  });

  // Copy link functionality
  const copyButton = document.querySelector('[data-copy-link]');
  
  if (copyButton) {
    copyButton.addEventListener('click', async () => {
      const url = copyButton.getAttribute('data-copy-link');
      
      try {
        await navigator.clipboard.writeText(url);
        
        // Visual feedback
        const originalHTML = copyButton.innerHTML;
        copyButton.innerHTML = `
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        `;
        
        setTimeout(() => {
          copyButton.innerHTML = originalHTML;
        }, 2000);
        
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    });
  }

  // Reading progress bar
  const createProgressBar = () => {
    const progressBar = document.createElement('div');
    progressBar.className = 'reading-progress-bar';
    progressBar.innerHTML = '<div class="reading-progress-bar__fill"></div>';
    document.body.appendChild(progressBar);
    
    const fill = progressBar.querySelector('.reading-progress-bar__fill');
    
    window.addEventListener('scroll', () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight - windowHeight;
      const scrolled = window.scrollY;
      const progress = (scrolled / documentHeight) * 100;
      
      fill.style.width = `${Math.min(progress, 100)}%`;
    }, { passive: true });
  };

  // Add reading progress bar
  createProgressBar();

  // Smooth scroll for anchor links
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  anchorLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      if (href !== '#' && href.length > 1) {
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });

  // Image lazy loading enhancement
  const images = document.querySelectorAll('.editorial-article-content img');
  images.forEach(img => {
    img.addEventListener('load', () => {
      img.style.opacity = '0';
      img.style.transform = 'scale(0.95)';
      
      setTimeout(() => {
        img.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        img.style.opacity = '1';
        img.style.transform = 'scale(1)';
      }, 100);
    });
  });

});

// Add reading progress bar styles dynamically
const style = document.createElement('style');
style.textContent = `
  .reading-progress-bar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: rgba(0, 0, 0, 0.05);
    z-index: 9999;
  }
  
  .reading-progress-bar__fill {
    height: 100%;
    background: var(--color-foreground, #000);
    width: 0%;
    transition: width 0.1s ease;
  }
`;
document.head.appendChild(style);
